import { yupResolver } from '@hookform/resolvers/yup';
import {
  Box,
  CircularProgress,
  Grid,
  Link,
  MenuItem,
  Typography,
  useMediaQuery,
  FormControlLabel,
  FormHelperText,
} from '@mui/material';
import { useGA4React } from 'ga-4-react';
import moment from 'moment';
import React, { Fragment, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import * as yup from 'yup';
import { objectToArray } from '../../libs/helpers';
import {
  CountryList,
  EmploymentStatusList,
  IndustriesList,
  MaritalStatusList,
  Vehicles,
} from '../../libs/staticData';
import PrimaryButton from '../ui/buttons/primaryButton';
import Checkbox from '../ui/forms/fields/checkbox';
import GreatDatePicker from '../ui/forms/fields/datePicker';
import Input from '../ui/forms/fields/input';
import SearchDropdown from '../ui/forms/fields/searchDropDoown';
import Select from '../ui/forms/fields/select';
import { Report } from '../../libs/loggers';

function PersonDetails({
  extendedForm,
  data,
  submitionData,
  onNext,
  onBack,
  stepSlug,
  openSave,
  onSaveAndExit,
  isRaHelp,
  isBciApplication,
  isApexRihfOrQihf,
}) {
  let ga4React = useGA4React();

  const [showPostal, setShowPostal] = useState(true);
  const loading = useSelector((state) => state.submition.submition?.loading);
  const userId = useSelector((state) => state.submition.data?.userId);
  const page = window.location.pathname.replace(/^\/|\/$/g, '');
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const submitionId = useSelector((state) => state.submition.submition?.submitionId);

  const selectedVehicle = useSelector((state) => state.data.value?.vehicle);
  const actingOnBehalf = Vehicles.find((v) => v.name === selectedVehicle)?.actingOnBehalf;

  const PersonalDetailsFormValidationSchema = (
    data,
    isBciApplication,
    isApexRihfOrQihf,
    isRaHelp
  ) => {
    let baseValidationSchema = yup.object().shape({
      stepSlug: yup.string().required(),
      gender: yup.string().required('Please select your gender.'),
      dateOfBirth: yup
        .string()
        .required('Please select a valid date of birth')
        .typeError('Please select a valid date of birth'),

      maritalStatus: yup.string().required('Please complete your marital status.'),
      maritalStatusOther: yup.string().when('maritalStatus', {
        is: (maritalStatus) => maritalStatus === 'Other',
        then: yup.string().required("Please specify 'other' marital status."),
        otherwise: yup.string(),
      }),

      nationality: yup.string().when('isForeignNational', {
        is: (isForeignNational) =>
          isForeignNational === 'no' && (isBciApplication || isApexRihfOrQihf),
        then: yup.string().required('Please select a nationality.'),
      }),

      occupation: yup.string().when('isBciApplication' || 'isApexRihfOrQihf', {
        is: false,
        then: yup.string().required('Please select an occupation.'),
        otherwise: yup.string().notRequired(),
      }),

      otherOccupation: yup.string().when('occupation', {
        is: 'otherOccupation',
        then: yup.string().required('Please complete your occupation.'),
        otherwise: yup.string().notRequired(),
      }),

      employmentStatus: yup.string().when('isBciApplication', {
        is: false,
        then: yup.string().required('What is your employment status?'),
      }),

      industry: yup.string().required(),
      industryOther: yup.string().when('industry', {
        is: (industry) => industry === 'Other',
        then: yup.string().required("Please specify 'other' industry."),
        otherwise: yup.string(),
      }),

      idNumber: yup.string().when('isForeignNational', {
        is: (isForeignNational) =>
          isForeignNational === 'no' && (isBciApplication || isApexRihfOrQihf),
        then: yup.string().required('Your identification number is required.'),
      }),
      incomeTaxNo: yup.string().required('Your income tax number is required.'),

      streetAddressCo: yup.string(),

      streetAddressUnit: yup.string(),
      streetAddressComplex: yup.string(),
      streetAddressNo: yup.string(),
      streetAddressName: yup.string().required('What is your street address name?'),
      streetAddressSuburb: yup.string().required('Please complete the name of your suburb.'),
      streetAddressCity: yup.string().required('Please complete the name of your city.'),

      streetAddressCode: yup.string().required('Please provide us with your postal code.'),
      streetAddressCountry: yup.string().required('Please complete the country you live in.'),
      sameAsStreetAddress: yup.bool().default(false),
      postalAddress_1: yup.string().when('sameAsStreetAddress', {
        is: (sameAsStreetAddress) => !sameAsStreetAddress,
        then: yup.string().required('Please provide your postal address.'),
        otherwise: yup.string(),
      }),
      postalAddress_2: yup.string(),
      postalAddressSuburb: yup.string().when('sameAsStreetAddress', {
        is: (sameAsStreetAddress) => !sameAsStreetAddress,
        then: yup.string().required('Please provide postal suburb.'),
        otherwise: yup.string(),
      }),
      postalAddressCity: yup.string().when('sameAsStreetAddress', {
        is: (sameAsStreetAddress) => !sameAsStreetAddress,
        then: yup.string().required('Please provide postal City/Town.'),
        otherwise: yup.string(),
      }),
      postalAddressCode: yup.string().when('sameAsStreetAddress', {
        is: (sameAsStreetAddress) => !sameAsStreetAddress,
        then: yup.string().required('Please provide postal Code.'),
        otherwise: yup.string(),
      }),
      postalAddressCountry: yup.string().when('sameAsStreetAddress', {
        is: (sameAsStreetAddress) => !sameAsStreetAddress,
        then: yup.string().required('Please select postal country.'),
        otherwise: yup.string(),
      }),
      publicOfficial: yup.string().required('Are you a / or associated to a  public official?'),

      publicOfficialDetails: yup.string().when('publicOfficial', {
        is: (publicOfficial) => publicOfficial === 'Yes' && isRaHelp,
        then: yup
          .string()
          .when(
            [
              'domestic_pep_pip',
              'foreign_pep_pip',
              'politicallyExposed_pep_pip',
              'associated_pep_pip',
              'family_pep_pip',
            ],
            {
              is: (domestic, foreign, politicallyExposed, associated, family) =>
                !domestic && !foreign && !politicallyExposed && !associated && !family,
              then: yup.string().required('Please select at least one checkbox.'),
              otherwise: yup.string(),
            }
          ),
        otherwise: yup.string(),
      }),

      //Acting on behalf of investior.
      aobo: yup.bool().default(false),
      aoboTitle: yup.string().when('aobo', {
        is: (aobo) => aobo,
        then: yup.string().required('Please add a title.'),
        otherwise: yup.string(),
      }),
      aoboSurname: yup.string().when('aobo', {
        is: (aobo) => aobo,
        then: yup.string().required('Missing a First Name.'),
        otherwise: yup.string(),
      }),
      aoboFirstName: yup.string().when('aobo', {
        is: (aobo) => aobo,
        then: yup.string().required('Missing a Surname.'),
        otherwise: yup.string(),
      }),
      aoboNationality: yup.string().when('aobo', {
        is: (aobo) => aobo,
        then: yup.string().required('Please select a nationality.'),
        otherwise: yup.string(),
      }),
      aobOcccupation: yup.string().when('aobo', {
        is: (aobo) => aobo,
        then: yup.string().required('Please select a occupation.'),
        otherwise: yup.string(),
      }),
      aobOcccupationOther: yup.string().when('aobOcccupation', {
        is: (aobOcccupation) => aobOcccupation === 'Other',
        then: yup.string().required("Please specify 'other' occupation."),
        otherwise: yup.string(),
      }),
      aoboDateOfBirth: yup.mixed().when('aobo', {
        is: (val) => !!val,
        then: () =>
          yup
            .date()
            .nullable()
            .transform((current, original) =>
              original === '' || original === null ? null : current
            )
            .typeError('Please select a valid date of birth')
            .max(new Date(), 'Date of birth cannot be in the future')
            .required('Please select a valid date of birth'),
        otherwise: () =>
          yup
            .date()
            .nullable()
            .transform((current, original) =>
              original === '' || original === null ? null : current
            )
            .typeError('Date of birth must be a valid date')
            .max(new Date(), 'Date of birth cannot be in the future')
            .notRequired(),
      }),

      aoboIdNumber: yup.string().when('aobo', {
        is: (aobo) => aobo,
        then: yup.string().required('Your identification number is required.'),
        otherwise: yup.string(),
      }),
      aoboIncTaxNr: yup.string().when('aobo', {
        is: (aobo) => aobo,
        then: yup.string().required('Your income tax number is required.'),
        otherwise: yup.string(),
      }),
      aoboGender: yup.string().when('aobo', {
        is: (aobo) => aobo,
        then: yup.string().required('Please select a gender.'),
        otherwise: yup.string(),
      }),

      aoboStreetAddressCo: yup.string(),
      aoboStreetAddressUnit: yup.string(),
      aoboStreetAddressComplex: yup.string(),
      aoboStreetAddressNo: yup.string(),

      aoboStreetAddressName: yup.string().when('aobo', {
        is: (aobo) => aobo,
        then: yup.string().required('What is your street name?'),
        otherwise: yup.string(),
      }),

      aoboStreetAddressSuburb: yup.string().when('aobo', {
        is: (aobo) => aobo,
        then: yup.string().required('Please give us the name your your suburb.'),
        otherwise: yup.string(),
      }),

      aoboStreetAddressCity: yup.string().when('aobo', {
        is: (aobo) => aobo,
        then: yup.string().required('What city is this street?'),
        otherwise: yup.string(),
      }),

      aoboStreetAddressCode: yup.string().when('aobo', {
        is: (aobo) => aobo,
        then: yup.string().required('Please provide us with the postal code.'),
        otherwise: yup.string(),
      }),

      aoboStreetAddressCountry: yup.string().when('aobo', {
        is: (aobo) => aobo,
        then: yup.string().required('In what country is this address located?'),
        otherwise: yup.string(),
      }),

      aoboSameAsStreetAddress: yup.bool().default(false),
      aoboPostalAddress_1: yup.string().when(['aoboSameAsStreetAddress', 'aobo'], {
        is: (sameAsStreetAddress, aobo) => !sameAsStreetAddress && aobo,
        then: yup.string().required('Please provide postal address.'),
        otherwise: yup.string(),
      }),
      aoboPostalAddress_2: yup.string(),
      aoboPostalAddressSuburb: yup.string().when(['aoboSameAsStreetAddress', 'aobo'], {
        is: (sameAsStreetAddress, aobo) => !sameAsStreetAddress && aobo,
        then: yup.string().required('Please provide postal suburb otherwise specify Town.'),
        otherwise: yup.string(),
      }),
      aoboPostalAddressCity: yup.string().when(['aoboSameAsStreetAddress', 'aobo'], {
        is: (sameAsStreetAddress, aobo) => !sameAsStreetAddress && aobo,
        then: yup.string().required('Please provide postal City/Town.'),
        otherwise: yup.string(),
      }),
      aoboPostalAddressCode: yup.string().when(['aoboSameAsStreetAddress', 'aobo'], {
        is: (sameAsStreetAddress, aobo) => !sameAsStreetAddress && aobo,
        then: yup.string().required('Please provide postal Code.'),
        otherwise: yup.string(),
      }),
      aoboPostalAddressCountry: yup.string().when(['aoboSameAsStreetAddress', 'aobo'], {
        is: (sameAsStreetAddress, aobo) => !sameAsStreetAddress && aobo,
        then: yup.string().required('Please provide postal Country.'),
        otherwise: yup.string(),
      }),

      aoboCell: yup.string().when('aobo', {
        is: (aobo) => aobo,
        then: yup
          .string()
          .trim()
          .required('Please provide a cell number.')
          .matches(/^\+?[0-9 ]+$/, 'Please enter a valid cellphone number.'),
        otherwise: yup.string(),
      }),
      aoboEmail: yup.string().when('aobo', {
        is: (aobo) => aobo,
        then: yup
          .string()
          .required('Please provide an email address.')
          .email('Please enter a valid email address.'),
        otherwise: yup.string().nullable(), // optional fallback
      }),

      aoboCapacity: yup.string().when('aobo', {
        is: (aobo) => aobo,
        then: yup.string().required('Please select a capacity.'),
        otherwise: yup.string(),
      }),

      aoboPublicOfficial: yup.string().when('aobo', {
        is: (aobo) => aobo,
        then: yup.string().required('Please select if you are a public official.'),
        otherwise: yup.string(),
      }),

      aoboPublicOfficialDetails: yup.string().when(['aobo', 'aoboPublicOfficial'], {
        is: (aobo, aoboPublicOfficial) => aobo && aoboPublicOfficial === 'Yes',
        then: yup.string().required('Please provide details about the public official.'),
        otherwise: yup.string(),
      }),

      passportNumber: yup.string().when('isForeignNational', {
        is: (isForeignNational) =>
          isForeignNational === 'yes' && (isBciApplication || isApexRihfOrQihf),
        then: yup.string().required('Please complete your Passport Number'),
      }),
      passport_exp: yup
        .string()
        .nullable()
        .when('isForeignNational', {
          is: (isForeignNational) =>
            isForeignNational === 'yes' && (isBciApplication || isApexRihfOrQihf),
          then: yup
            .string()
            .required('Please complete your Passport Expiry Date')
            .typeError('Please complete your Passport Expiry Date'),
        }),
      passport_country_of_issue: yup.string().when('isForeignNational', {
        is: (isForeignNational) =>
          isForeignNational === 'yes' && (isBciApplication || isApexRihfOrQihf),
        then: yup.string().required('Please select your Passport Country Of Issue'),
      }),

      ...(isBciApplication || isApexRihfOrQihf
        ? {
            isForeignNational: yup
              .string()
              .required('Please select whether you are a Foreign National'),
            country_of_birth: yup.string().required('Please complete Country of Birth.'),
          }
        : {}),
    });

    return baseValidationSchema;
  };

  const {
    register,
    control,
    formState: { errors },
    watch,
    handleSubmit,
    setValue,
    getValues,
  } = useForm({
    mode: 'all',
    resolver: yupResolver(
      PersonalDetailsFormValidationSchema(data, isBciApplication, isApexRihfOrQihf, isRaHelp)
    ),
  });

  const apexIndustries = [
    'indAerospaceDefense',
    'indAgriForestFish',
    'indBanksFinancialServices',
    'indCasinos',
    'indCommTechology',
    'indConstructionEngineering',
    'indDigitalAssetsCryptoFund',
    'indDiversifiedMetalsMining',
    'indEducation',
    'indArtEntertnmntRecr',
    'indHealthcareServices',
    'indInternetGamblingOnlineBetting',
    'indManufacturing',
    'indPreciousMetalsMinerals',
    'indRealEstateServices',
    'indRetail',
    'indStateOwnedEntityGovernment',
    'indTransprtStorageLogist',
    'indUtilities',
  ];

  const bciIndustries = [
    'indAgriForestFish',
    'indArmedForces',
    'indSales',
    'indEducation',
    'indExecitive',
    'indGovEmployee',
    'indManager',
    'indGovrmntSOE',
    'indRetired',
    'indProfServices',
    'indSelfEmployed',
    'indIT',
    'indUnemployed',
  ];

  const watchStreetAddressCountry = watch('streetAddressCountry');
  const watchIndustry = watch('industry');
  useEffect(() => {
    setValue('stepSlug', stepSlug, { shouldValidate: true });
  }, [stepSlug, setValue]);

  useEffect(() => {}, [watchIndustry, setValue]);

  useEffect(() => {
    if (window.innerWidth <= 768) {
      window.scrollTo(0, 0);
    }
  }, []);
  useEffect(() => {
    const selectedCountry = watchStreetAddressCountry;
    const selectedCountryObject = CountryList.find((country) => country.label === selectedCountry);
    if (selectedCountryObject) {
      setValue('country_code', selectedCountryObject.code);
    }
    setValue('citizenship', watchStreetAddressCountry);
    setValue('country_of_residence', watchStreetAddressCountry);
  }, [watchStreetAddressCountry, setValue]);

  const formStepperSteps = useSelector((state) => state.formStepper.value.formSectionsSteps);
  const formStepper = useSelector((state) => state.formStepper.value);

  const nationalityWatch = watch('nationality');
  useEffect(() => {
    setValue('countryTaxResidence1', nationalityWatch, {
      shouldValidate: true,
      shouldDirty: true,
    });
  }, [nationalityWatch, setValue]);

  const incomeTaxWatch = watch('incomeTaxNo');

  useEffect(() => {
    setValue('taxReferenceNumber1', incomeTaxWatch, {
      shouldValidate: true,
      shouldDirty: true,
    });
  }, [incomeTaxWatch, setValue]);

  useEffect(() => {
    if (submitionData) {
      Object.entries(submitionData).forEach(([key, value]) => {
        setValue(key, value, { validate: true });
      });
    }
  }, [submitionData, setValue]);

  const postalWatch = watch('sameAsStreetAddress');
  useEffect(() => {
    setShowPostal(!postalWatch);
  }, [postalWatch]);

  useEffect(() => {
    const eventInfo = {
      action: 'view',
      category: 'step4_formstep_view',
      description: 'viewed a form step in step 4',
      value: {
        currentPage: page,
        stepSlug,
        activeFormStep: formStepper?.step,
      },
    };

    Report(eventInfo, userId, submitionId);
  }, []);

  const NavButtons = (props) => (
    <>
      <Box display="flex" justifyContent={'flex-end'}>
        <PrimaryButton disabled={props.isFirstStep} onClick={() => onBack()} sx={{ mt: 1, mr: 1 }}>
          Back
        </PrimaryButton>
        <PrimaryButton
          onClick={() => handleNext()}
          disabled={loading}
          sx={{
            mt: 1,
            mr: 1,
            '&.Mui-disabled': {
              background: '#CC6323',
              color: '#fff',
            },
          }}
        >
          {userId ? 'Save & Continue' : 'Continue'}{' '}
          {loading && <CircularProgress sx={{ ml: 1 }} size={isMobile ? 15 : 20} color="inherit" />}
        </PrimaryButton>
        <PrimaryButton variant="outlined" onClick={() => handleSaveAndExit(userId)} sx={{ mt: 1 }}>
          {'Save & Exit'}
        </PrimaryButton>
      </Box>
      {!userId && (
        <Box display="flex" justifyContent={'flex-end'} marginTop={1}>
          <Typography variant="body1">
            {' '}
            Your progress is not being saved. Click{' '}
            <Link
              sx={{ cursor: 'pointer' }}
              variant="body1"
              underline="always"
              onClick={() => {
                handleOpenSave();
              }}
            >
              here
            </Link>{' '}
            to save.
          </Typography>
        </Box>
      )}
    </>
  );

  const handleNext = async () => {
    ga4React.event('complete_form_step', `${stepSlug}`, 'investement_submition');

    setValue('completeProcess', false, { shouldValidate: true });

    if (isBciApplication || isApexRihfOrQihf) {
      const validIndustries = isBciApplication ? bciIndustries : apexIndustries;

      if (watchIndustry && !validIndustries.includes(watchIndustry)) {
        const industryObj = IndustriesList.find((item) => item.key === watchIndustry);

        if (industryObj) {
          setValue('industryOther', industryObj.value || '');
          setValue('industry', 'Other');
        }
      }
    }

    handleSubmit(onSubmit)();
  };

  const handleSaveAndExit = (userId) => {
    const data = getValues();
    const newSubmition = { ...submitionData, ...data };
    onSaveAndExit(newSubmition, userId);
  };

  const handleOpenSave = () => {
    const data = getValues();
    const newSubmition = { ...submitionData, ...data };
    openSave(newSubmition);
  };

  const onSubmit = (data) => {
    const newSubmition = { ...submitionData, ...data };
    onNext(newSubmition);
  };

  return (
    <>
      {actingOnBehalf && (
        <Checkbox
          name={'aobo'}
          label="I am a parent/guardian acting on behalf of a minor."
          control={control}
        />
      )}

      {watch('aobo') && (
        <Grid container spacing={1}>
          <Box display={'flex'} flexDirection={'column'} mt={3} p={1}>
            <Typography variant="h4" color="primary">
              Acting on behalf of Investor
            </Typography>
            <Typography mt={1}>
              *** Please provide us with the details of the person who is authorised to act on
              behalf of the investor.
            </Typography>
          </Box>

          <Grid item xs={12} md={6}>
            <Input
              required
              label="Title"
              {...register('aoboTitle')}
              error={!!errors.aoboTitle}
              helperText={errors?.aoboTitle?.message}
            />
            <Input
              label="First Names"
              {...register('aoboFirstName')}
              required
              error={!!errors.aoboFirstName}
              helperText={errors?.aoboFirstName?.message}
            />
            <Input
              label="Surname"
              {...register('aoboSurname')}
              required
              error={!!errors.aoboSurname}
              helperText={errors?.aoboSurname?.message}
            />
            <GreatDatePicker
              name={'aoboDateOfBirth'}
              control={control}
              label="Date Of Birth"
              error={!!errors.aoboDateOfBirth}
              helperText={errors?.aoboDateOfBirth?.message}
              maxDate={moment()}
              openTo={'year'}
            />

            <Input
              required
              label="Identification Number"
              {...register('aoboIdNumber')}
              error={!!errors.aoboIdNumber}
              helperText={errors?.aoboIdNumber?.message}
            />
            <Input
              label="Cellphone Number"
              {...register('aoboCell')}
              required
              error={!!errors.aoboCell}
              helperText={errors?.aoboCell?.message}
            />

            {watch('aobOcccupation') === 'Other' ? (
              <Input
                required
                label={`Please specify Other Occupation `}
                {...register('aobOcccupationOther')}
                error={!!errors.aobOcccupationOther}
                helperText={errors?.aobOcccupationOther?.message}
              />
            ) : null}
          </Grid>
          <Grid item xs={12} md={6}>
            <Select
              required
              name="aoboGender"
              label="Gender"
              control={control}
              error={!!errors.aoboGender}
              helperText={errors?.aoboGender?.message}
            >
              <MenuItem value="Male">Male</MenuItem>
              <MenuItem value="Female">Female</MenuItem>
            </Select>

            <SearchDropdown
              name="aoboNationality"
              label="Nationality"
              control={control}
              error={!!errors.aoboNationality}
              helperText={errors?.aoboNationality?.message}
              options={CountryList}
              required
            />
            <Input
              required
              label="Income Tax Number"
              {...register('aoboIncTaxNr')}
              error={!!errors.aoboIncTaxNr}
              helperText={errors?.aoboIncTaxNr?.message}
            />
            <Select
              required
              name="aoboCapacity"
              label="Capacity of Authorization"
              control={control}
              error={!!errors.aoboCapacity}
              helperText={errors?.aoboCapacity?.message}
            >
              <MenuItem value="Parent">Parent</MenuItem>
              <MenuItem value="Guardian">Guardian</MenuItem>
              <MenuItem value="Guardian">Power of attorney</MenuItem>
            </Select>
            <Input
              label="Email Address"
              {...register('aoboEmail')}
              error={!!errors.aoboEmail}
              required
            />
            <Select
              required
              name="aobOcccupation"
              label={'Occupation'}
              control={control}
              error={!!errors.aobOcccupation}
              helperText={errors?.aobOcccupation?.message}
            >
              {IndustriesList.map((item) => (
                <MenuItem key={item.key} value={item.key}>
                  {item.value}
                </MenuItem>
              ))}
              <MenuItem value={'Other'}>Other</MenuItem>
            </Select>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box>
              <Typography variant="h5" color="primary" sx={{ margin: '8.5px 0' }}>
                Physical Address
              </Typography>
            </Box>

            <Input
              label="Corner Of"
              {...register('aoboStreetAddressCo')}
              error={!!errors.aoboStreetAddressCo}
              helperText={errors?.aoboStreetAddressCo?.message}
            />
            <Input
              label="Unit"
              {...register('aoboStreetAddressUnit')}
              error={!!errors.aoboStreetAddressUnit}
              helperText={errors?.aoboStreetAddressUnit?.message}
            />
            <Input
              label="Complex"
              {...register('aoboStreetAddressComplex')}
              error={!!errors.aoboStreetAddressComplex}
              helperText={errors?.aoboStreetAddressComplex?.message}
            />

            <Input
              label="Street No"
              {...register('aoboStreetAddressNo')}
              error={!!errors.aoboStreetAddressNo}
              helperText={errors?.aoboStreetAddressNo?.message}
            />
            <Input
              required
              label="Street Name"
              {...register('aoboStreetAddressName')}
              error={!!errors.aoboStreetAddressName}
              helperText={errors?.aoboStreetAddressName?.message}
            />
            <Input
              required
              label="Suburb"
              {...register('aoboStreetAddressSuburb')}
              error={!!errors.aoboStreetAddressSuburb}
              helperText={errors?.aoboStreetAddressSuburb?.message}
            />
            <Input
              required
              label="City"
              {...register('aoboStreetAddressCity')}
              error={!!errors.aoboStreetAddressCity}
              helperText={errors?.aoboStreetAddressCity?.message}
            />
            <Input
              required
              label="Postal Code"
              {...register('aoboStreetAddressCode')}
              error={!!errors.aoboStreetAddressCode}
              helperText={errors?.aoboStreetAddressCode?.message}
            />
            <SearchDropdown
              required
              name="aoboStreetAddressCountry"
              label="Country"
              control={control}
              error={!!errors.aoboStreetAddressCountry}
              helperText={errors?.aoboStreetAddressCountry?.message}
              options={CountryList}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
              <Typography variant="h5" color="primary">
                Postal Address
              </Typography>
              <Checkbox
                name={'aoboSameAsStreetAddress'}
                label="Same as Physical Address"
                control={control}
              />
            </Box>
            {!watch('aoboSameAsStreetAddress') ? (
              <Fragment>
                <Input
                  required
                  label="Line 1"
                  {...register('aoboPostalAddress_1')}
                  error={!!errors.aoboPostalAddress_1}
                  helperText={errors?.aoboPostalAddress_1?.message}
                />
                <Input
                  required
                  label="Line 2"
                  {...register('aoboPostalAddress_2')}
                  error={!!errors.aoboPostalAddress_2}
                  helperText={errors?.aoboPostalAddress_2?.message}
                />
                <Input
                  required
                  label="Suburb"
                  {...register('aoboPostalAddressSuburb')}
                  error={!!errors.aoboPostalAddressSuburb}
                  helperText={errors?.aoboPostalAddressSuburb?.message}
                />
                <Input
                  required
                  label="City"
                  {...register('aoboPostalAddressCity')}
                  error={!!errors.aoboPostalAddressCity}
                  helperText={errors?.aoboPostalAddressCity?.message}
                />
                <Input
                  required
                  label="Postal Code"
                  {...register('aoboPostalAddressCode')}
                  error={!!errors.aoboPostalAddressCode}
                  helperText={errors?.aoboPostalAddressCode?.message}
                />
                <SearchDropdown
                  name="aoboPostalAddressCountry"
                  label="Country"
                  control={control}
                  error={!!errors.aoboPostalAddressCountry}
                  helperText={errors?.aoboPostalAddressCountry?.message}
                  options={CountryList}
                  required
                />
              </Fragment>
            ) : null}
          </Grid>
          <Grid item xs={12} md={12}>
            <Typography variant="h5" color="primary" sx={{ margin: '8.5px 0' }}>
              Public Official
            </Typography>
          </Grid>
          <Grid item xs={12} md={12}>
            <Typography>
              I consider myself to be, or to be associated with a Domestic Prominent Influential
              Person or a Foreign Prominent Public Official.
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Select
              required
              name="aoboPublicOfficial"
              label="Public Official"
              control={control}
              error={!!errors.aoboPublicOfficial}
              helperText={errors?.aoboPublicOfficial?.message}
            >
              <MenuItem value="Yes">Yes</MenuItem>
              <MenuItem value="No">No</MenuItem>
            </Select>

            {watch('aoboPublicOfficial') === 'Yes' && (
              <Input
                required
                label="Please provide details"
                multiline
                {...register('aoboPublicOfficialDetails')}
                error={!!errors.aoboPublicOfficialDetails}
                helperText={errors?.aoboPublicOfficialDetails?.message}
              />
            )}
          </Grid>
        </Grid>
      )}

      <Grid container spacing={1}>
        <Box display={'flex'} flexDirection={'column'} mt={3} p={1}>
          <Typography variant="h4" color="primary">
            Investor Details
          </Typography>
          <Typography mt={1}>
            ***Please provide your contact details, or those of the investor if you are applying on
            their behalf.
          </Typography>
        </Box>
        <Grid item xs={12} md={6}>
          <GreatDatePicker
            name={'dateOfBirth'}
            control={control}
            label="Date Of Birth"
            error={!!errors.dateOfBirth}
            helperText={errors?.dateOfBirth?.message}
            openTo={'year'}
          />
          {isBciApplication || isApexRihfOrQihf ? (
            <Select
              required
              id="isForeignNational"
              name="isForeignNational"
              label="Are you a foreign national?"
              control={control}
              error={!!errors.isForeignNational}
              helperText={errors?.isForeignNational?.message}
            >
              <MenuItem value="yes">Yes</MenuItem>
              <MenuItem value="no">No</MenuItem>
            </Select>
          ) : (
            <Input
              required
              label="Identification Number"
              {...register('idNumber')}
              error={!!errors.idNumber}
              helperText={errors?.idNumber?.message}
            />
          )}
          {watch('isForeignNational') === 'no' && (
            <Input
              required
              label="Identification Number"
              {...register('idNumber')}
              error={!!errors.idNumber}
              helperText={errors?.idNumber?.message}
            />
          )}
          {watch('isForeignNational') === 'yes' && (
            <>
              {' '}
              <Input
                required
                label="Passport Number"
                {...register('passportNumber')}
                error={!!errors.passportNumber}
                helperText={errors?.passportNumber?.message}
              />
              <SearchDropdown
                id="passport_country_of_issue"
                name="passport_country_of_issue"
                label="Passport Country Of Issue"
                control={control}
                error={!!errors.passport_country_of_issue}
                helperText={errors?.passport_country_of_issue?.message}
                options={CountryList}
                required
              />
            </>
          )}
          {!isBciApplication && !isApexRihfOrQihf && (
            <>
              <Select
                required
                label="Occupation"
                name="occupation"
                control={control}
                error={!!errors.occupation}
                helperText={errors?.occupation?.message}
              >
                <MenuItem value="">Please select</MenuItem>
                <MenuItem value="formallyEmployed">Formally Employed</MenuItem>
                <MenuItem value="selfEmployed">Self-Employed</MenuItem>
                <MenuItem value="unemployed">Unemployed</MenuItem>
                <MenuItem value="retired">Retired/ Pensioner</MenuItem>
                <MenuItem value="minor">Minor</MenuItem>
                <MenuItem value="otherOccupation">Other</MenuItem>
              </Select>

              {watch('occupation') === 'otherOccupation' && (
                <Input
                  required
                  label="Other Occupation"
                  {...register('otherOccupation')}
                  error={!!errors.otherOccupation}
                  helperText={errors?.otherOccupation?.message}
                />
              )}
            </>
          )}
          {!isBciApplication && (
            <Select
              required
              name="employmentStatus"
              label="Employment Status"
              control={control}
              error={!!errors.employmentStatus}
              helperText={errors?.employmentStatus?.message}
            >
              {EmploymentStatusList.map((item) => (
                <MenuItem key={item.key} value={item.key}>
                  {item.value}
                </MenuItem>
              ))}
            </Select>
          )}

          <Select
            required
            name="industry"
            label={isBciApplication || isApexRihfOrQihf ? 'Occupation' : 'Industry'}
            control={control}
            error={!!errors.industry}
            helperText={errors?.industry?.message}
          >
            {IndustriesList.map((item) => (
              <MenuItem key={item.key} value={item.key}>
                {item.value}
              </MenuItem>
            ))}
            <MenuItem value={'Other'}>Other</MenuItem>
          </Select>

          {watch('industry') === 'Other' ? (
            <Input
              required
              label={`Please specify Other 'Industry'}`}
              {...register('industryOther')}
              error={!!errors.industryOther}
              helperText={errors?.industryOther?.message}
            />
          ) : null}
        </Grid>
        <Grid item xs={12} md={6}>
          <Select
            required
            name="gender"
            label="Gender"
            control={control}
            error={!!errors.gender}
            helperText={errors?.gender?.message}
          >
            <MenuItem value="Male">Male</MenuItem>
            <MenuItem value="Female">Female</MenuItem>
          </Select>

          {watch('isForeignNational') === 'no' && (isBciApplication || isApexRihfOrQihf) && (
            <SearchDropdown
              id="nationality"
              name="nationality"
              label="Nationality"
              control={control}
              error={!!errors.nationality}
              helperText={errors?.nationality?.message}
              options={CountryList}
              required
            />
          )}
          {isBciApplication ||
            (isApexRihfOrQihf && (
              <SearchDropdown
                id="country_of_birth"
                name="country_of_birth"
                label="Country Of Birth"
                control={control}
                error={!!errors.country_of_birth}
                helperText={errors?.country_of_birth?.message}
                options={CountryList}
                required
              />
            ))}
          {!isBciApplication && !isApexRihfOrQihf && (
            <SearchDropdown
              id="nationality"
              name="nationality"
              label="Nationality"
              control={control}
              error={!!errors.nationality}
              helperText={errors?.nationality?.message}
              options={CountryList}
              required
            />
          )}

          {watch('isForeignNational') === 'yes' && (
            <GreatDatePicker
              name={'passport_exp'}
              control={control}
              label="Passport Expiry Date"
              error={!!errors.passport_exp}
              helperText={errors?.passport_exp?.message}
              openTo={'year'}
              minDate={moment()}
            />
          )}
          <Select
            required
            name="maritalStatus"
            label="Marital Status"
            control={control}
            error={!!errors.maritalStatus}
            helperText={errors?.maritalStatus?.message}
          >
            {MaritalStatusList.map((item) => (
              <MenuItem key={item.key} value={item.key}>
                {item.value}
              </MenuItem>
            ))}
            {/* <MenuItem value="Other">Other</MenuItem> */}
          </Select>
          <Input
            required
            label="Income Tax Number"
            {...register('incomeTaxNo')}
            error={!!errors.incomeTaxNo}
            helperText={errors?.incomeTaxNo?.message}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Box>
            <Typography variant="h5" color="primary" sx={{ margin: '8.5px 0' }}>
              Physical Address
            </Typography>
          </Box>

          <Input
            label="Corner Of"
            {...register('streetAddressCo')}
            error={!!errors.streetAddressCo}
            helperText={errors?.streetAddressCo?.message}
          />
          <Input
            label="Unit"
            {...register('streetAddressUnit')}
            error={!!errors.streetAddressUnit}
            helperText={errors?.streetAddressUnit?.message}
          />
          <Input
            label="Complex"
            {...register('streetAddressComplex')}
            error={!!errors.streetAddressComplex}
            helperText={errors?.streetAddressComplex?.message}
          />

          <Input
            label="Street No"
            {...register('streetAddressNo')}
            error={!!errors.streetAddressNo}
            helperText={errors?.streetAddressNo?.message}
          />
          <Input
            required
            label="Street Name"
            {...register('streetAddressName')}
            error={!!errors.streetAddressName}
            helperText={errors?.streetAddressName?.message}
          />
          <Input
            required
            label="Suburb"
            {...register('streetAddressSuburb')}
            error={!!errors.streetAddressSuburb}
            helperText={errors?.streetAddressSuburb?.message}
          />
          <Input
            required
            label="City"
            {...register('streetAddressCity')}
            error={!!errors.streetAddressCity}
            helperText={errors?.streetAddressCity?.message}
          />
          <Input
            required
            label="Postal Code"
            {...register('streetAddressCode')}
            error={!!errors.streetAddressCode}
            helperText={errors?.streetAddressCode?.message}
          />
          <SearchDropdown
            required
            name="streetAddressCountry"
            label="Country"
            control={control}
            error={!!errors.streetAddressCountry}
            helperText={errors?.streetAddressCountry?.message}
            options={CountryList}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
            <Typography variant="h5" color="primary">
              Postal Address
            </Typography>
            <Checkbox
              name={'sameAsStreetAddress'}
              label="Same as Physical Address"
              control={control}
            />
          </Box>
          {showPostal ? (
            <Fragment>
              <Input
                required
                label="Line 1"
                {...register('postalAddress_1')}
                error={!!errors.postalAddress_1}
                helperText={errors?.postalAddress_1?.message}
              />
              <Input
                required
                label="Line 2"
                {...register('postalAddress_2')}
                error={!!errors.postalAddress_2}
                helperText={errors?.postalAddress_2?.message}
              />
              <Input
                required
                label="Suburb"
                {...register('postalAddressSuburb')}
                error={!!errors.postalAddressSuburb}
                helperText={errors?.postalAddressSuburb?.message}
              />
              <Input
                required
                label="City"
                {...register('postalAddressCity')}
                error={!!errors.postalAddressCity}
                helperText={errors?.postalAddressCity?.message}
              />
              <Input
                required
                label="Postal Code"
                {...register('postalAddressCode')}
                error={!!errors.postalAddressCode}
                helperText={errors?.postalAddressCode?.message}
              />
              <SearchDropdown
                name="postalAddressCountry"
                label="Country"
                control={control}
                error={!!errors.postalAddressCountry}
                helperText={errors?.postalAddressCountry?.message}
                options={CountryList}
                required
              />
            </Fragment>
          ) : null}
        </Grid>{' '}
        <Grid item xs={12} md={12}>
          <Typography variant="h5" color="primary" sx={{ margin: '8.5px 0' }}>
            Public Official
          </Typography>
        </Grid>
        <Grid item xs={12} md={12}>
          <Typography>
            I consider myself to be, or to be associated with a Domestic Prominent Influential
            Person or a Foreign Prominent Public Official.
          </Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <Select
            required
            name="publicOfficial"
            label="Public Official"
            control={control}
            error={!!errors.publicOfficial}
            helperText={errors?.publicOfficial?.message}
          >
            <MenuItem value="Yes">Yes</MenuItem>
            <MenuItem value="No">No</MenuItem>
          </Select>

          {watch('publicOfficial') === 'Yes' && !isRaHelp && (
            <Input
              required
              label="Please provide details"
              multiline
              {...register('publicOfficialDetails')}
              error={!!errors.publicOfficialDetails}
              helperText={errors?.publicOfficialDetails?.message}
            />
          )}

          {/* Public Official Details */}
        </Grid>
        {watch('publicOfficial') === 'Yes' && isRaHelp && (
          <Grid container spacing={1}>
            <Grid item xs={12} md={4}>
              <Checkbox
                {...register('domestic_pep_pip')}
                defaultChecked={false}
                label="Domestic prominent influential person"
                control={control}
                error={!!errors.publicOfficialDetails}
              />
            </Grid>{' '}
            <Grid item xs={12} md={4}>
              <Checkbox
                {...register('foreign_pep_pip')}
                defaultChecked={false}
                label="Foreign prominent public official"
                control={control}
                error={!!errors.publicOfficialDetails}
              />
            </Grid>{' '}
            <Grid item xs={12} md={4}>
              <Checkbox
                {...register('politicallyExposed_pep_pip')}
                defaultChecked={false}
                label="Politically-exposed person"
                control={control}
                error={!!errors.publicOfficialDetails}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Checkbox
                {...register('associated_pep_pip')}
                defaultChecked={false}
                label="Known close associate to a prominent person"
                control={control}
                error={!!errors.publicOfficialDetails}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Checkbox
                {...register('family_pep_pip')}
                defaultChecked={false}
                label="Family member of one of the above"
                control={control}
                error={!!errors.publicOfficialDetails}
              />
            </Grid>
          </Grid>
        )}
        {errors.publicOfficialDetails && (
          <FormHelperText error={!!errors.publicOfficialDetails}>
            {errors.publicOfficialDetails.message}
          </FormHelperText>
        )}
        <Grid item xs={12} md={12}>
          <NavButtons isLastStep={false} isFirstStep={false} index={0} />
        </Grid>
        <Box display={'inlineBlock'}>
          {objectToArray(errors).map((error, index) => (
            <Typography color={'error'} key={index}>
              {error.value.message}
            </Typography>
          ))}
        </Box>
      </Grid>
    </>
  );
}

export default PersonDetails;
